var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
// NOTIFICATION_FRAGMENT
export default gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment NOTIFICATION_FRAGMENT on Notification {\n    id\n    active\n    created_at\n    data\n    source_id\n    source_type\n    type\n  }\n"], ["\n  fragment NOTIFICATION_FRAGMENT on Notification {\n    id\n    active\n    created_at\n    data\n    source_id\n    source_type\n    type\n  }\n"])));
var templateObject_1;
